import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";

import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

interface SelectFindDropdownProps {
  setSearchQueryValue: (searchQuery: string) => void;
}
function SelectFindDropdown(props: SelectFindDropdownProps) {
  const findHistory = useSelector((state: RootState) => state.qCDetailPageState.findHistory);
  const searchHandleMenuClick: MenuProps["onClick"] = (e) => {
    props.setSearchQueryValue(e.key);
  };
  const noValueSearchMenuProps = {
    items: [{ label: "No previous search", key: "No previous search" }],
    onClick: () => {},
  };
  const findMenuProps = {
    items: findHistory.map((item: string) => ({
      key: item,
      label: item,
    })),
    onClick: searchHandleMenuClick,
  };
  return (
    <Dropdown
      menu={findHistory.length === 0 ? noValueSearchMenuProps : findMenuProps}
      trigger={["click"]}>
      <div className="dropdown-btn">
        <SearchOutlined />
        <DownOutlined />
      </div>
    </Dropdown>
  );
}

export default SelectFindDropdown;
